module.exports = __webpack_public_path__ + "img/prj06.d48762fa.png";